import { createApp } from 'vue';

import SalaryIndex from 'JIX/components/salaryindex/SalaryIndex.vue';
import HighchartsVue from 'highcharts-vue';

const stash = window.Stash['salaryindex/default'];

const analytics = [
    { 'id': 'salaryindex-search-job-link', 'label': 'search' },
    { 'id': 'salaryindex_create_cv_btn',   'label': 'cv' },
];

analytics.forEach((element) => {
    document.querySelector('#' + element.id).addEventListener('click', () =>
        window.jixAnalytics('event', {
            category: 'salaryindex',
            action:   'click',
            label:    element.label,
        })
    );
});

const app = createApp(SalaryIndex, stash);
app.use(HighchartsVue);
app.mount('#app');
